// extracted by mini-css-extract-plugin
export default {"knowAboutPcp":"styles_knowAboutPcp__oYN2T","twoCols":"styles_twoCols__cF9lw","facts":"styles_facts__mawL1","fact":"styles_fact__CKREJ","innerFact":"styles_innerFact__qRCTe"};